/**
 * Personal Consultation overview ("Medication Counseling") — BS-1157.
 *
 * Reachable from both Instant Buy and Shop & Collect product detail screens,
 * for products in a medical (advice-required) category.
 *
 * Figma: https://www.figma.com/design/NBnn0MEdCHdbMj2LsWQqng/Consumer-App?node-id=21650-44998
 */
import { preloadQuery } from "@relay";
import { createFileRoute } from "@tanstack/react-router";
import { usePreloadedQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { ConsultationOverview } from "~/components/PersonalConsultation/ConsultationOverview";
import type { consultationOverviewQuery } from "./__generated__/consultationOverviewQuery.graphql";

export const query = graphql`
	query consultationOverviewQuery($hubName: String!) @relay_test_operation {
		hubMeta(by: { name: $hubName }) @required(action: THROW) {
			id
			...ConsultationOverviewFragment
		}
	}
`;

export const Route = createFileRoute("/$hubMetaName/consultation/")({
	beforeLoad: () => {
		document.title = "bacehub | Medication Counseling";
	},
	component: RouteComponent,
	loader: (ctx) =>
		preloadQuery<consultationOverviewQuery>(ctx.context.relayEnvironment, query, {
			hubName: ctx.params.hubMetaName,
		}),
});

function RouteComponent() {
	const { hubMetaName } = Route.useParams();
	const { hubMeta } = usePreloadedQuery<consultationOverviewQuery>(query, Route.useLoaderData());

	return <ConsultationOverview hubMeta={hubMeta} hubMetaName={hubMetaName} />;
}
